module.exports = "/_next/static/images/Supercharge@2x-13750d2444a866d8c9490416004b89de.webp";